import React, { useState } from "react";
import PopoutShapeMenu from "../utilities/PopoutShapeMenu";
import PopoutDrawMenu from "../utilities/PopoutDrawMenu";
import HelpModal from "../utilities/HelpModal";

const HIDDEN_ON_MOBILE = ["export", "redo"];

const Toolbar = ({
  activeTool,
  onSelectTool,
  onAction,
  isPlaying = false,
  selectedShape,
  onSelectShape,
  drawingColor,
  onDrawingColorChange,
}) => {
  const [shapeMenuOpen, setShapeMenuOpen] = useState(false);
  const [shapeMenuAnchor, setShapeMenuAnchor] = useState({ x: 0, y: 0 });
  const [drawMenuOpen, setDrawMenuOpen] = useState(false);
  const [drawMenuAnchor, setDrawMenuAnchor] = useState({ x: 0, y: 0 });
  const [helpOpen, setHelpOpen] = useState(false);
  const playLabel = isPlaying ? "Pause" : "Play";

  const buttons = [
    { id: "home", label: "Home", icon: "/icons/Chevron.png" },
    { id: "move", label: "Move", icon: "/icons/Move.png" },
    { id: "draw", label: "Draw", icon: "/icons/Pencil.png", isDrawMenu: true },
    { id: "shapes", label: "Shapes", icon: "⬠", isMenu: true },
    // { id: "text", label: "Text", icon: "/icons/Text.png" },
    { id: "callouts", label: "Callouts", icon: "/icons/Callouts.png" },
    { id: "objective", label: "Obj", icon: "/icons/Objectives.png" },
    { id: "play", label: playLabel, icon: isPlaying ? "/icons/Pause.png" : "/icons/Play.png" },
    { id: "undo", label: "Undo", icon: "/icons/Undo.png" },
    { id: "redo", label: "Redo", icon: "/icons/Redo.png" },
    { id: "export", label: "Export", icon: "/icons/Export-image.png" },
    { id: "clear", label: "Clear", icon: "/icons/Trash.png" },
    { id: "help", label: "Help", icon: "/icons/Help.png" },
  ];

  const actionButtons = ["clear", "home", "undo", "redo", "play", "callouts", "objective", "export"];
  // const toggleButtons = ["objective", "callouts"];

  const handleShapeButtonClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setShapeMenuAnchor({ x: rect.right + 8, y: rect.top });
    setShapeMenuOpen(!shapeMenuOpen);
  };

  const handleDrawButtonClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setDrawMenuAnchor({ x: rect.right + 8, y: rect.top });
    setDrawMenuOpen((open) => !open);
  };

  return (
    <div className="toolbar" role="toolbar" aria-orientation="vertical">
      {buttons.map((b) => (
        <button
          key={b.id}
          className={`toolbar-btn ${
            HIDDEN_ON_MOBILE.includes(b.id) ? "hide-on-mobile" : ""
          } ${
            selectedShape && b.id === "shapes"
              ? "active"
              : b.id === "draw" && activeTool === "eraser"
                ? "active"
                : activeTool === b.id ? "active" : ""
          }`}
          aria-pressed={selectedShape && b.id === "shapes"
            ? true
            : b.id === "draw" ? activeTool === "draw" || activeTool === "eraser" : activeTool === b.id}
          data-draw-menu-trigger={b.isDrawMenu ? "true" : undefined}
          title={b.label}
          onClick={(e) => {
            if (b.isMenu) {
              handleShapeButtonClick(e);
            } else if (b.isDrawMenu) {
              handleDrawButtonClick(e);
            } else if (b.id === "help") {
              setHelpOpen(true);
            } else if (actionButtons.includes(b.id)) {
              onAction(b.id);
            } else {
              onSelectTool(b.id);
            }
          }}
        >
          {b.icon ? (
            b.icon.startsWith("/") ? (
              <img src={b.icon} alt={b.label} className="toolbar-icon" />
            ) : (
              <span style={{ fontSize: "18px", fontWeight: "bold" }}>{b.icon}</span>
            )
          ) : (
            b.label
          )}
        </button>
      ))}

      <PopoutShapeMenu
        visible={shapeMenuOpen}
        anchor={shapeMenuAnchor}
        selectedShape={selectedShape}
        onSelectShape={(shape) => {
          onSelectShape(shape);
          onSelectTool("shapes");
        }}
        onClose={() => setShapeMenuOpen(false)}
      />
      <PopoutDrawMenu
        visible={drawMenuOpen}
        anchor={drawMenuAnchor}
        activeTool={activeTool}
        color={drawingColor}
        onSelectTool={onSelectTool}
        onColorChange={onDrawingColorChange}
        onClose={() => setDrawMenuOpen(false)}
      />
      <HelpModal
        visible={helpOpen}
        onClose={() => setHelpOpen(false)}
      />
    </div>
  );
};

export default Toolbar;